import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { langType, withLang } from '../../../i18n';
import {
  downloadOpenQuestionResponsesExport
} from '../../../api';
import { surveyTypeValues } from '../../../constants/types';
import {
  isSurveyForDegreeProgram
} from '../../../util';

const OpenEndedQuestions = ({
  surveyInfo,
  surveyStats,
  surveyType,
  translate: t
}) => {
  const { openQuestionCount, openQuestionResponseCount, id } = surveyInfo;

  if (!surveyStats || !surveyInfo || !isSurveyForDegreeProgram(surveyType)) {
    return null;
  }
  return (
    <>
      <h2><Translate id="surveyStatistics.responsesToOpenQuestions" />{surveyStats === 'true' }</h2>
      <p>{`${t('surveyStatistics.openQuestionCount')} ${openQuestionCount}`}</p>
      { (openQuestionResponseCount > 0) && (
        <button type="button" className="button" onClick={() => downloadOpenQuestionResponsesExport(id)}>
          <Translate id="surveyStatistics.viewOpenQuestionResponseReport" />
        </button>
      ) }
    </>
  );
};

const {
  shape,
  oneOf
} = PropTypes;

OpenEndedQuestions.propTypes = {
  surveyInfo: shape(),
  surveyStats: shape(),
  surveyType: oneOf(Object.values(surveyTypeValues)).isRequired,
  ...langType
};

OpenEndedQuestions.defaultProps = {
  surveyInfo: null,
  surveyStats: null
};

export default withLang(OpenEndedQuestions);
